
import { MainLayout } from "@/components/MainLayout";
import { CalendarView } from "@/components/Calendar";
import { SEO } from "@/components/SEO";

export default function CalendarPage() {
  return (
    <MainLayout>
      <SEO 
        title="Calendário"
        description="Visualize suas obrigações financeiras em um calendário interativo, acompanhe vencimentos e organize melhor suas finanças."
        keywords="calendário financeiro, vencimentos, obrigações financeiras, organização mensal"
      />
      <CalendarView />
    </MainLayout>
  );
}
